export default __webpack_public_path__ + "static/media/assets-foiling_01.b0cb98f1.jpg";